// extracted by mini-css-extract-plugin
export default {"wrapper":"OitMnT_MP6","title":"FjWNOjVo62","event":"cwrMOOXxZO","eventTitle":"nM0XNIvSdC","group":"N4yv21Wrjl","info":"KOSYvYbzhc","infoItem":"QhmlD9XWtR","output":"EAg64bTYBB"};